import EventStudioPage from './EventStudioPage'

export { EventStudioPage }

export default EventStudioPage
